exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".app-main .main-bd .el-row[data-v-7dcbb45b]{padding:20px 0}.my-input-width[data-v-7dcbb45b]{width:58px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7dcbb45b","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/order/expressTable.vue
// module id = 2279
// module chunks = 0